import { render, staticRenderFns } from "./laudoAtendimento.vue?vue&type=template&id=3ced494b"
import script from "./laudoAtendimento.vue?vue&type=script&lang=js"
export * from "./laudoAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports